import { Link } from "react-router-dom";
import { FIRM } from "@/data/firm";
import { VISIBLE_PRACTICE_AREAS } from "@/data/practiceAreas";

export default function Footer() {
  return (
    <footer className="bg-ink text-ivory mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-12 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h2 className="font-serif text-3xl sm:text-4xl tracking-tight text-ivory leading-tight">
            Shelton Law<br/>PLLC
          </h2>
          <p className="mt-6 text-ivory/70 text-sm leading-relaxed max-w-md">
            {FIRM.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.28em] text-brass-light font-semibold mb-5">Practice Areas</p>
          <ul className="space-y-2.5 text-sm">
            {VISIBLE_PRACTICE_AREAS.map((p) => (
              <li key={p.slug}>
                <Link
                  to={`/services/${p.slug}`}
                  className="text-ivory/80 hover:text-brass-light transition-colors"
                  data-testid={`footer-practice-${p.slug}`}
                >
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-[11px] uppercase tracking-[0.28em] text-brass-light font-semibold mb-5">Firm</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="text-ivory/80 hover:text-brass-light transition-colors" data-testid="footer-about-link">About</Link></li>
            <li><Link to="/people" className="text-ivory/80 hover:text-brass-light transition-colors" data-testid="footer-people-link">People</Link></li>
            <li><Link to="/services" className="text-ivory/80 hover:text-brass-light transition-colors" data-testid="footer-services-link">Practice Areas</Link></li>
            <li><Link to="/resources" className="text-ivory/80 hover:text-brass-light transition-colors" data-testid="footer-resources-link">Guides</Link></li>
            <li><Link to="/blog" className="text-ivory/80 hover:text-brass-light transition-colors" data-testid="footer-blog-link">Insights</Link></li>
            <li><Link to="/news" className="text-ivory/80 hover:text-brass-light transition-colors" data-testid="footer-news-link">News</Link></li>
            <li><Link to="/contact" className="text-ivory/80 hover:text-brass-light transition-colors" data-testid="footer-contact-link">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-[11px] uppercase tracking-[0.28em] text-brass-light font-semibold mb-5">Contact</p>
          <ul className="space-y-2.5 text-sm">
            <li><a href={FIRM.emailHref} className="text-ivory/80 hover:text-brass-light transition-colors break-all" data-testid="footer-email">{FIRM.email}</a></li>
            <li><a href={FIRM.careersEmailHref} className="text-ivory/80 hover:text-brass-light transition-colors break-all" data-testid="footer-careers-email">{FIRM.careersEmail}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ivory/15">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-[11px] text-ivory/55 tracking-wide">
          <p>© {new Date().getFullYear()} {FIRM.longName}. All rights reserved.</p>
          <p className="max-w-2xl md:text-right">
            Attorney advertising. Prior results do not guarantee a similar outcome.{" "}
            <Link to="/legal" className="underline decoration-ivory/30 hover:text-brass-light hover:decoration-brass-light transition-colors" data-testid="footer-legal-link">
              Legal Notices
            </Link>
            .
          </p>
        </div>
      </div>
    </footer>
  );
}
